import {Text, View} from "@react-pdf/renderer";
import React, {useContext} from "react";

import { baseStyles } from "../styles";
import {PDFContext} from "../BasePDF";

export const CapitalizedCostBreakdownPDF = ( { isCustomerWorksheet } ) => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null;

    return (
        <View style={{...baseStyles.marginRight, ...baseStyles.table}}>
            <View style={{...baseStyles.tableHeader, backgroundColor: pdfData.pageColor}}>
                <Text>Capitalized Cost Breakdown</Text>
            </View>

            <View>
                {
                    !isCustomerWorksheet &&
                    <>
                        <View style={baseStyles.flexBetween}>
                            <Text
                                style={baseStyles.flex}
                            >
                                Vehicle Cost
                            </Text>
                            <Text>
                                {pdfData.vehicle_cost.toDollarFormat()}
                            </Text>
                        </View>

                        <View style={baseStyles.flexBetween}>
                            <Text>Profit</Text>
                            <Text>{pdfData.profit.toDollarFormat()}</Text>
                        </View>
                    </>
                }

                <View style={{...baseStyles.flexBetween, ...baseStyles.boldTopBorder}}>
                    <Text>Selling Price</Text>
                    <Text>{pdfData.selling_price.toDollarFormat()}</Text>
                </View>

                {
                    pdfData.dealer_incentive && pdfData.dealer_incentive !== '0' &&
                    <View style={baseStyles.flexBetween}>
                        <Text>Dealer Incentive</Text>
                        <Text>{pdfData.dealer_incentive.toDollarFormat()}</Text>
                    </View>
                }

                {
                    pdfData.inception_fees_capitalized && pdfData.inception_fees_capitalized !== '0' &&
                    <View style={baseStyles.flexBetween}>
                        <Text>Inception Fees (Capitalized)</Text>
                        <Text>{pdfData.inception_fees_capitalized.toDollarFormat()}</Text>
                    </View>
                }
                {
                    pdfData.cap_reduction_cash && pdfData.cap_reduction_cash !== '0' &&
                    <View style={baseStyles.flexBetween}>
                        <Text>Cash as Cap Reduction</Text>
                        <Text>{pdfData.cap_reduction_cash.toDollarFormat()}</Text>
                    </View>
                }
                {
                    pdfData.rebate_as_cap_reduction && pdfData.rebate_as_cap_reduction !== '0' &&
                    <View style={{...baseStyles.flexBetween}}>
                        <Text>Rebate as Cap Reduction</Text>
                        <Text>{pdfData.rebate_as_cap_reduction.toDollarFormat()}</Text>
                    </View>
                }
                {
                    pdfData.trade_as_cap_reduction && pdfData.trade_as_cap_reduction !== '0' &&
                    <View style={{...baseStyles.flexBetween}}>
                        <Text>Trade as Cap Reduction</Text>
                        <Text>{pdfData.trade_as_cap_reduction.toDollarFormat()}</Text>
                    </View>
                }
                {
                    pdfData.trade_as_negative_equity && pdfData.trade_as_negative_equity !== '0' &&
                    <View style={{...baseStyles.flexBetween}}>
                        <Text>Trade as Negative Equity</Text>
                        <Text>{pdfData.trade_as_negative_equity.toDollarFormat()}</Text>
                    </View>
                }
                {
                    pdfData.cap_cost_breakdown.map((value) => {
                        if (value.amount === "0" || value.amount === "0.0") return null;
                        return (
                            <View style={baseStyles.flexBetween}>
                                <Text>{value.name}</Text>
                                <Text>{value.amount.toDollarFormat()}</Text>
                            </View>
                        )
                    })
                }

                {/*{*/}
                {/*    pdfData.capitalized_taxes && pdfData.capitalized_taxes !== '0' &&*/}
                {/*    <View style={{...baseStyles.flexBetween}}>*/}
                {/*        <Text>Capitalized Taxes</Text>*/}
                {/*        <Text>{pdfData.capitalized_taxes.toDollarFormat()}</Text>*/}
                {/*    </View>*/}
                {/*}*/}

                <View style={{...baseStyles.flexBetween, ...baseStyles.boldTopBorder}}>
                    <Text>Total Capital Cost</Text>
                    <Text>{pdfData.total_capital_cost.toDollarFormat()}</Text>
                </View>
            </View>
        </View>
    )
}